import { z } from 'zod';
import { publicPostSchema, publicProfileSchema } from './api.js';
const objectStatsSchema = z.object({
    day: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    week: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    month: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    quarter: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
    year: z.object({
        currentPeriod: z.number(),
        lastPeriod: z.number(),
    }),
});
const objectStatsWithAllSchema = objectStatsSchema.extend({
    all: z.number(),
});
export const publicPostWithActivityScoreSchema = publicPostSchema.extend({
    activityScore: z.number(),
});
export const publicProfileWithActivityScoreSchema = publicProfileSchema.extend({
    activityScore: z.number(),
});
const topPostsListSchema = publicPostWithActivityScoreSchema.array().max(5);
const _topProfilesListSchema = publicProfileWithActivityScoreSchema
    .array()
    .max(5);
export const topPostsSchema = z.object({
    day: topPostsListSchema,
    week: topPostsListSchema,
    month: topPostsListSchema,
    quarter: topPostsListSchema,
    year: topPostsListSchema,
});
export const topProfilesSchema = z.object({
    day: publicProfileWithActivityScoreSchema.array().max(5),
    week: publicProfileWithActivityScoreSchema.array().max(5),
    month: publicProfileWithActivityScoreSchema.array().max(5),
    quarter: publicProfileWithActivityScoreSchema.array().max(5),
    year: publicProfileWithActivityScoreSchema.array().max(5),
});
export const profilesStatsSchema = z.object({
    all: objectStatsWithAllSchema,
    active: objectStatsWithAllSchema,
});
export const postsStatsSchema = z.object({
    all: objectStatsWithAllSchema,
    withoutReply: objectStatsWithAllSchema,
    withReplies: objectStatsWithAllSchema,
    replies: objectStatsWithAllSchema,
});
export const interactionsStatsSchema = z.object({
    all: objectStatsWithAllSchema,
});
export const jamsStatsSchema = z.object({
    sessions: objectStatsWithAllSchema,
    participants: objectStatsWithAllSchema,
});
export const topListsStatsSchema = z.object({
    posts: topPostsSchema,
    profiles: topProfilesSchema,
});
export const timelinesStatsSchema = z.object({
    signups: z.object({
        week: z
            .object({
            name: z.string(),
            count: z.number(),
        })
            .array(),
        fourWeeks: z
            .object({
            name: z.string(),
            count: z.number(),
        })
            .array(),
        fourMonths: z
            .object({
            name: z.string(),
            count: z.number(),
        })
            .array(),
    }),
});
export const serverCountsSchema = z.object({
    profiles: z.number(),
    posts: z.number(),
    events: z.number(),
    reactions: z.number(),
    rsvps: z.number(),
});
export const hostResourceStatsSchema = z.object({
    memoryUsedBytes: z.number().nonnegative(),
    memoryTotalBytes: z.number().nonnegative(),
    cpuUsedPercent: z.number().min(0).max(100),
});
export const adminServerStatsSchema = z.object({
    profiles: profilesStatsSchema,
    posts: postsStatsSchema,
    interactions: interactionsStatsSchema,
    jams: jamsStatsSchema,
    topLists: topListsStatsSchema,
    timelines: timelinesStatsSchema,
    host: hostResourceStatsSchema,
});
export const profileActivitySummarySchema = z.object({
    postsCount: z.number().int().nonnegative(),
    repliesCount: z.number().int().nonnegative(),
    eventsCount: z.number().int().nonnegative(),
    reactionsGiven: z.number().int().nonnegative(),
    reactionsReceived: z.number().int().nonnegative(),
    repostsCount: z.number().int().nonnegative(),
    repostsReceived: z.number().int().nonnegative(),
    repliesReceived: z.number().int().nonnegative(),
    rsvpsCount: z.number().int().nonnegative(),
    bookmarksCount: z.number().int().nonnegative(),
    groupsCount: z.number().int().nonnegative(),
    topPosts: publicPostWithActivityScoreSchema.array().max(5),
});
export const adminProfileSummarySchema = z.object({
    profile: publicProfileSchema,
    activity: profileActivitySummarySchema,
    createdAt: z.string().datetime(),
    email: z.string().optional(),
    followersCount: z.number().int().nonnegative(),
    followingCount: z.number().int().nonnegative(),
    reportsCount: z.number().int().nonnegative(),
    blockedByCount: z.number().int().nonnegative(),
});
